import React, { ButtonHTMLAttributes } from 'react';
import css from './button.module.css';
import Spinner from '../../../../../../components/common/spinner';

export default function Button({
  className = '',
  text = '',
  disabled = false,
  loading = false,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  text?: string;
}) {
  return (
    <button
      {...props}
      className={`${css['button']} ${className}`}
      disabled={disabled || loading ? true : false}
    >
      {loading && <Spinner className={`${css['spinner']}`} visible />}
      <span>{text}</span>
    </button>
  );
}
